<template>
  <div class="my-plugins">
    <div class="panel-page">
      <div class="panel-heading">
        <h2>我的插件</h2>
        <span class="pull-right">
          <el-button type="primary" size="small" icon="el-icon-plus" @click="goForm()">上传插件</el-button>
        </span>
      </div>

      <!-- 统计条 -->
      <el-row :gutter="12" class="stat-row">
        <el-col :span="6" v-for="item in statCards" :key="item.key">
          <div class="stat-card" :class="{ active: queryParams.auditStatus === item.key }" @click="filterByStatus(item.key)">
            <p class="stat-num">{{ item.count }}</p>
            <p class="stat-label">{{ item.label }}</p>
          </div>
        </el-col>
      </el-row>

      <el-form :inline="true" size="small" class="filter-bar">
        <el-form-item label="插件名称">
          <el-input v-model="queryParams.pluginName" placeholder="请输入插件名称" clearable @keyup.enter.native="handleQuery" />
        </el-form-item>
        <el-form-item label="分类">
          <el-select v-model="queryParams.cateId" placeholder="全部分类" clearable>
            <el-option v-for="cate in cateList" :key="cate.cateId" :label="cate.cateName" :value="cate.cateId" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="handleQuery">查询</el-button>
          <el-button icon="el-icon-refresh" @click="resetQuery">重置</el-button>
        </el-form-item>
      </el-form>

      <el-table v-loading="loading" :data="list" style="width: 100%">
        <el-table-column label="插件" min-width="220">
          <template slot-scope="scope">
            <div class="plugin-cell">
              <img :src="scope.row.pluginThumb || '/img/default_avatar.png'" class="plugin-thumb">
              <div>
                <p class="plugin-name">{{ scope.row.pluginName }}</p>
                <p class="plugin-code">代码名：{{ scope.row.codeName }}</p>
                <p class="plugin-code">最新版本：{{ scope.row.latestVersion || '未上传' }}（共 {{ scope.row.versionCount }} 个版本）</p>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="分类" prop="cateName" width="110" />
        <el-table-column label="售价（元）" width="140">
          <template slot-scope="scope">
            <p>基础版：{{ formatYuan(scope.row.pluginPrice) }}</p>
            <p>高级版：{{ formatYuan(scope.row.pluginPrice2) }}</p>
          </template>
        </el-table-column>
        <el-table-column label="审核状态" width="130">
          <template slot-scope="scope">
            <el-tag :type="auditTagType(scope.row.auditStatus)" size="small">{{ auditText(scope.row.auditStatus) }}</el-tag>
            <p v-if="scope.row.auditStatus === 3" class="reject-text">{{ scope.row.auditRemark }}</p>
          </template>
        </el-table-column>
        <el-table-column label="销售中" width="90">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.soldOut === 0 && scope.row.auditStatus === 2" type="success" size="small">销售中</el-tag>
            <el-tag v-else type="info" size="small">未上架</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="下载 / 销量" width="110">
          <template slot-scope="scope">{{ scope.row.downloadTimes }} / {{ scope.row.orderCount }}</template>
        </el-table-column>
        <el-table-column label="累计收益（元）" width="120">
          <template slot-scope="scope">
            <span class="income-text">{{ scope.row.incomeSumStr || '0.00' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="230" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" size="mini" @click="goForm(scope.row.pluginId)">编辑</el-button>
            <el-button type="text" size="mini" @click="goVersion(scope.row.pluginId)">版本</el-button>
            <el-button
              type="text"
              size="mini"
              v-if="scope.row.auditStatus === 0 || scope.row.auditStatus === 3"
              @click="submitAudit(scope.row)">提交审核</el-button>
            <el-button
              type="text"
              size="mini"
              v-if="scope.row.auditStatus === 2"
              @click="toggleSoldOut(scope.row)">{{ scope.row.soldOut === 1 ? '上架' : '下架' }}</el-button>
            <el-button type="text" size="mini" class="del-btn" @click="removePlugin(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div v-if="!loading && list.length === 0" class="empty-box">
        <i class="el-icon-box empty-icon"></i>
        <p>还没有上传任何插件</p>
        <el-button type="primary" @click="goForm()">上传我的第一个插件</el-button>
      </div>

      <el-pagination
        v-if="total > 0"
        class="pager"
        background
        layout="total, prev, pager, next"
        :total="total"
        :current-page.sync="queryParams.pageNum"
        :page-size="queryParams.pageSize"
        @current-change="getList" />
    </div>
  </div>
</template>

<script>
import {
  listMyPlugins,
  submitPluginAudit,
  changePluginSoldOut,
  deleteMyPlugin,
  getPluginCate
} from '@/api/developer'

export default {
  name: 'myPlugins',
  data () {
    return {
      loading: true,
      list: [],
      cateList: [],
      total: 0,
      statSource: [],
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        pluginName: '',
        cateId: '',
        auditStatus: ''
      }
    }
  },
  computed: {
    statCards () {
      const count = (status) => this.statSource.filter(item => Number(item.auditStatus) === status).length
      return [
        { key: '', label: '全部插件', count: this.statTotal },
        { key: '2', label: '已通过', count: count(2) },
        { key: '1', label: '待审核', count: count(1) },
        { key: '3', label: '已驳回', count: count(3) }
      ]
    },
    statTotal () {
      return this.statSource.length
    }
  },
  methods: {
    formatYuan (value) {
      const num = Number(value || 0) / 100
      return num.toFixed(2)
    },
    auditText (status) {
      const map = { 0: '草稿', 1: '待审核', 2: '已通过', 3: '已驳回' }
      return map[Number(status)] || '草稿'
    },
    auditTagType (status) {
      const map = { 0: 'info', 1: 'warning', 2: 'success', 3: 'danger' }
      return map[Number(status)] || 'info'
    },
    getList () {
      this.loading = true
      listMyPlugins(this.queryParams).then(res => {
        const { code, data, msg } = res
        if (code === 0) {
          this.list = data.list || []
          this.total = data.total || 0
        } else {
          this.$message.error(msg || '获取插件列表失败')
        }
      }).finally(() => {
        this.loading = false
      })
    },
    loadStats () {
      // 统计条基于全量数据（不带分页与筛选）统计
      listMyPlugins({ pageNum: 1, pageSize: 200 }).then(res => {
        const { code, data } = res
        if (code === 0) {
          this.statSource = data.list || []
        }
      })
    },
    loadCate () {
      getPluginCate().then(res => {
        const { code, data } = res
        if (code === 0 && Array.isArray(data)) {
          this.cateList = data
        }
      })
    },
    filterByStatus (status) {
      this.queryParams.auditStatus = status
      this.handleQuery()
    },
    handleQuery () {
      this.queryParams.pageNum = 1
      this.getList()
    },
    resetQuery () {
      this.queryParams.pluginName = ''
      this.queryParams.cateId = ''
      this.queryParams.auditStatus = ''
      this.handleQuery()
    },
    goForm (pluginId) {
      this.$router.push({ path: 'developerPluginForm', query: pluginId ? { pluginId: pluginId } : {} })
    },
    goVersion (pluginId) {
      this.$router.push({ path: 'developerPluginVersion', query: { pluginId: pluginId } })
    },
    submitAudit (row) {
      this.$confirm(`确认提交「${row.pluginName}」进行平台审核？提交后审核期间不可修改。`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        submitPluginAudit(row.pluginId).then(res => {
          const { code, msg } = res
          if (code === 0) {
            this.$message.success(msg || '已提交审核')
            this.refresh()
          } else {
            this.$message.error(msg || '提交失败')
          }
        })
      }).catch(() => {})
    },
    toggleSoldOut (row) {
      const soldOut = row.soldOut === 1 ? 0 : 1
      const text = soldOut === 1 ? '下架' : '上架'
      this.$confirm(`确认${text}「${row.pluginName}」？下架后买家将无法购买，已产生的订单与收益不受影响。`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        changePluginSoldOut(row.pluginId, soldOut).then(res => {
          const { code, msg } = res
          if (code === 0) {
            this.$message.success(msg || `${text}成功`)
            this.refresh()
          } else {
            this.$message.error(msg || `${text}失败`)
          }
        })
      }).catch(() => {})
    },
    removePlugin (row) {
      this.$confirm(`确认删除「${row.pluginName}」？该操作不可恢复。`, '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteMyPlugin(row.pluginId).then(res => {
          const { code, msg } = res
          if (code === 0) {
            this.$message.success(msg || '删除成功')
            this.refresh()
          } else {
            this.$message.error(msg || '删除失败')
          }
        })
      }).catch(() => {})
    },
    refresh () {
      this.getList()
      this.loadStats()
    }
  },
  created () {
    this.loadCate()
    this.loadStats()
    this.getList()
  }
}
</script>

<style lang="less" scoped>
.my-plugins {
  .panel-heading {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 20px;

    h2 {
      margin: 0;
      font-size: 22px;
      color: #303133;
    }
  }

  .stat-row {
    margin-bottom: 18px;
  }

  .stat-card {
    padding: 16px 12px;
    text-align: center;
    border: 1px solid #ebeef5;
    border-radius: 6px;
    cursor: pointer;
    transition: all 0.2s;

    &:hover {
      border-color: #0d95e8;
      box-shadow: 0 2px 12px rgba(13, 149, 232, 0.15);
    }

    &.active {
      border-color: #0d95e8;
      background: #f0f9ff;
    }

    .stat-num {
      margin: 0;
      font-size: 24px;
      font-weight: 600;
      color: #303133;
    }

    .stat-label {
      margin: 6px 0 0 0;
      font-size: 13px;
      color: #909399;
    }
  }

  .filter-bar {
    margin-bottom: 8px;
  }

  .plugin-cell {
    display: flex;
    align-items: center;

    .plugin-thumb {
      width: 56px;
      height: 56px;
      object-fit: cover;
      border-radius: 4px;
      margin-right: 12px;
      background: #f5f7fa;
    }

    .plugin-name {
      margin: 0 0 4px 0;
      font-weight: 600;
      color: #303133;
    }

    .plugin-code {
      margin: 0;
      font-size: 12px;
      color: #909399;
      line-height: 18px;
    }
  }

  .reject-text {
    margin: 4px 0 0 0;
    font-size: 12px;
    color: #f56c6c;
    line-height: 16px;
  }

  .income-text {
    color: #f56c6c;
    font-weight: 600;
  }

  .del-btn {
    color: #f56c6c;
  }

  .empty-box {
    padding: 50px 0;
    text-align: center;
    color: #909399;

    .empty-icon {
      font-size: 48px;
      color: #c0c4cc;
    }

    p {
      margin: 14px 0 18px 0;
    }
  }

  .pager {
    margin-top: 18px;
    text-align: right;
  }
}
</style>
